export type UseFullSizeToggle = {
  fullSize: Ref<boolean>;
  toggleFullSize: () => void;
};

export const INJECT_FUILLSIZE_TOGGLE = Symbol(
  'useFullSizeToggle composable'
) as InjectionKey<UseFullSizeToggle>;

export const useFullSizeToggle = (): UseFullSizeToggle => {
  const fullSize = ref<boolean>(false);

  const toggleFullSize = () => {
    fullSize.value = !fullSize.value;
  };

  return {
    fullSize,
    toggleFullSize,
  };
};
